export enum PriceChartFilter {
  ONE_WEEK = "week",
  ONE_MONTH = "month",
  TWO_MONTHS = "twoMonths",
}
